import type { FilaProveedorCotizado } from "../types/cotizacionProveedores.types";

const esObjeto = (v: unknown): v is Record<string, unknown> => typeof v === "object" && v !== null;
const aTexto = (v: unknown): string => (v === undefined || v === null ? "" : String(v).trim());
const aNumero = (v: unknown): number => Number(v) || 0;

export const normalizarProveedoresCotizados = (proveedores: unknown): FilaProveedorCotizado[] =>
    (Array.isArray(proveedores) ? proveedores : []).filter(esObjeto).map((p, i) => {
        const detalles = Array.isArray(p.detalles) ? p.detalles.filter(esObjeto) : [];

        const productos = detalles.map((d, j) => {
            const cantidad = aNumero(d.cantidad);
            const precioUnitario = aNumero(d.precio_unitario);
            return {
                id: aTexto(d.id) || `${i}-${j}`,
                idInventario: aNumero(d.id_inventario),
                nombre: aTexto(d.nombre_producto) || aTexto(d.equipo) || "—",
                cantidad,
                precioUnitario,
                total: cantidad * precioUnitario,
                seleccionado: aNumero(d.seleccionado),
                gestionado: aNumero(d.gestionado),
                disponibilidad:
                    d.disponibilidad === null || d.disponibilidad === undefined
                        ? null
                        : aNumero(d.disponibilidad),
            };
        });

        return {
            id: aTexto(p.id_cotizacion_proveedor) || String(i),
            nombreComercial: aTexto(p.nombre_comercial),
            razonSocial: aTexto(p.razon_social),
            contacto: aTexto(p.contacto),
            correo: aTexto(p.correo),
            rfc: aTexto(p.rfc),
            telefono: aTexto(p.telefono),
            total: productos.reduce((acc, x) => acc + x.total, 0),
            respondido: p.respondido === true,
            totalProductos: aNumero(p.total_productos),
            productosGestionados: aNumero(p.productos_gestionados),
            productos,
        };
    });